import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, timeout, catchError, throwError } from "rxjs";
import { PwaService } from "../../pages/pwa-install-prompt/pwa.service";

@Injectable({ providedIn: "root" })
export class HttpTimeoutInterceptor implements HttpInterceptor {
	private pwaService = inject(PwaService);

	// Longer timeout for PWA mode (30s) due to service worker overhead
	private readonly PWA_TIMEOUT_MS = 30000;
	private readonly DEFAULT_TIMEOUT_MS = 15000;

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const timeoutDuration = this.pwaService.isInPwaMode()
			? this.PWA_TIMEOUT_MS
			: this.DEFAULT_TIMEOUT_MS;

		return next.handle(req).pipe(
			timeout(timeoutDuration),
			catchError((error) => {
				if (error.name === "TimeoutError") {
					return throwError(() => ({
						...error,
						message: `Request timeout after ${timeoutDuration}ms`,
						isTimeout: true
					}));
				}
				return throwError(() => error);
			})
		);
	}
}
